import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://protocolzenith.com/products/protocolo-zenith-la-ingenieria-de-la-estrategia-crediticia-diy?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative flex flex-col items-center justify-center w-full max-w-md mx-auto bg-zenith-red hover:bg-zenith-redDark text-white px-8 py-5 rounded-lg shadow-[0_0_20px_rgba(153,27,27,0.3)] hover:shadow-[0_0_30px_rgba(153,27,27,0.5)] transition-all duration-300 no-underline ${className}`} data-id="element-1">
      <span className="flex items-center text-lg md:text-xl font-bold tracking-wide mb-1" data-id="element-2">
        QUIERO EL PROTOCOLO ZENITH
        <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-3" />
      </span>
      <span className="text-sm md:text-base text-white/80 font-medium" data-id="element-4">
        Acceso Inmediato por Solo $6.83
      </span>
    </motion.a>;
}